import React from 'react';
import { Input, InputSizes } from '@clockout-dev/design-elements';
import { UserOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import SectionCard from '../../common/sectionCard/SectionCard';
import styles from '../styles/account.module.scss';

/**
 * Pure presentational card for the "Personal Information" section. Owns the
 * 2-column form layout for name / email / phone — every value lands here as
 * props from the orchestrator and every keystroke routes back through the
 * `onChange*` callbacks. Inputs share the design-system `Input` so styling
 * (focus ring, error tone, prefix icon) stays in the package.
 */
function PersonalInformationCard({
    firstName,
    lastName,
    email,
    phoneNumber,
    hasError,
    onFirstNameChange,
    onLastNameChange,
    onEmailChange,
    onPhoneNumberChange,
}) {
    const errorStatus = hasError ? 'error' : '';

    return (
        <SectionCard icon={<UserOutlined />} title="Personal Information">
            <div className={styles.formGrid}>
                <Input
                    size={InputSizes.SMALL}
                    id="firstName"
                    label="First name"
                    prefix={<UserOutlined className={styles.inputIcon} />}
                    value={firstName || ''}
                    onChange={(e) => onFirstNameChange?.(e.target.value)}
                    placeholder="First name"
                    status={errorStatus}
                    autoComplete="given-name"
                />

                <Input
                    size={InputSizes.SMALL}
                    id="lastName"
                    label="Last name"
                    prefix={<UserOutlined className={styles.inputIcon} />}
                    value={lastName || ''}
                    onChange={(e) => onLastNameChange?.(e.target.value)}
                    placeholder="Last name"
                    status={errorStatus}
                    autoComplete="family-name"
                />

                <Input
                    size={InputSizes.SMALL}
                    id="email"
                    label="Email"
                    type="email"
                    prefix={<MailOutlined className={styles.inputIcon} />}
                    value={email || ''}
                    onChange={(e) => onEmailChange?.(e.target.value)}
                    placeholder="email@example.com"
                    status={errorStatus}
                    autoComplete="email"
                />

                <Input
                    size={InputSizes.SMALL}
                    id="phoneNumber"
                    label="Phone number"
                    prefix={<PhoneOutlined className={styles.inputIcon} />}
                    value={phoneNumber || ''}
                    onChange={(e) => onPhoneNumberChange?.(e.target.value)}
                    placeholder="(555) 123-4567"
                    status={errorStatus}
                    autoComplete="tel"
                />
            </div>
        </SectionCard>
    );
}

export default PersonalInformationCard;
